export enum VerticalPlaylist {
  GtlPlaylistOffers = 'gtlPlaylistOffers',
  ModuleOffers = 'moduleOffers',
  ModuleVenues = 'moduleVenues',
  SimilarOffers = 'similarOffers',
  ThematicSearchOffers = 'thematicSearchOffers',
  ThematicSearchVenues = 'thematicSearchVenues',
  VenueOffers = 'venueOffers',
  ArtistOffers = 'artistOffers',
}
